import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";

function Leaderboard() {
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	const items = [];
	// const prevScrollY = useRef(0);
	let history = useHistory();
	useEffect(() => {
		localStorage.setItem("loader", "free");
		getLeaderboardData();
	}, []);
	const [leaderData, setLeaderData] = useState({"status":"failuer","self":{"dist_user_id": "","rank": "NA","points": 0,"name": "","city": "","profile_pic": ""},"leaders":[]});
	const [error1, setError] = useState(false);
	const [seasonAward, setSeasonAward] = useState('');
	const [leaders, setLeaders] = useState([]);
	const [startRank, setStartRank] = useState(1);
	const [endRank, setEndRank] = useState(10);

	const prevScrollY = useRef(0);
  	const [goingUp, setGoingUp] = useState(false);
	const onScroll = (e) => {
		const currentScrollY = e.target.scrollTop;
		if (prevScrollY.current < currentScrollY && goingUp) {
			setGoingUp(false);
		}
		if (prevScrollY.current > currentScrollY && !goingUp) {
			setGoingUp(true);
		}
		prevScrollY.current = currentScrollY;
		if (Math.ceil(window.innerHeight +currentScrollY - 256) === e.target.scrollHeight) {
			// Do load more content here!
			console.log("bottom");
			loadMore("down")
		}
		if(currentScrollY === 0){
			console.log("top");
			loadMore("up")
		}
	};

	async function loadMore(params){
		if(localStorage.getItem("loader") === "free"){
			localStorage.setItem("loader", "loading");
		if(params === "down"){
			let s = endRank + 1;
			let e = endRank + 10;
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
				body: JSON.stringify({dist_user_id:user_id,start_rank:s,end_rank:e}),	
			};
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				setError(true);
			}
			for (const [index, value] of data.leaders.entries()) {
				let pp = '';
				if(value.profile_pic === 'NA' || value.profile_pic === ''){
					pp = require("./../images/defaultProfile.png").default;
				} else {
					pp = value.profile_pic;
				}
				items.push(<li key={value.dist_user_id}>
				  	<a className="item">
					  <span className="leader-number">{value.rank}</span>
					  <img src={pp} alt="image" className="image" />
					  <div className="in">
						  <div className="leader">
							  {value.name}
							  <footer className="leader-state">{value.city}</footer>
						  </div>
						  <span className="leader-points">{value.points}<span className="border-bottom-red"> pts</span></span>
					  </div>
				  	</a>
			  	</li>);
		 	}
			setLeaders(leaders.concat(items));
			setEndRank(data.end_rank);
		}
		if(params === "up"){
			let s = startRank - 10;
			if(s <= 0){
				s= 1;
			}
			let e = startRank - 1;
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
				body: JSON.stringify({dist_user_id:user_id,start_rank:s,end_rank:e,order:"desc"}),	
			};
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				setError(true);
			}
			//var new_items = [];
			for (const [index, value] of data.leaders.entries()) {
				let pp = '';
				if(value.profile_pic === 'NA' || value.profile_pic === ''){
					pp = require("./../images/defaultProfile.png").default;
				} else {
					pp = value.profile_pic;
				}
				leaders.unshift(<li key={value.dist_user_id}>
				  <a className="item">
					  <span className="leader-number">{value.rank}</span>
					  <img src={pp} alt="image" className="image" />
					  <div className="in">
						  <div className="leader">
							  {value.name}
							  <footer className="leader-state">{value.city}</footer>
						  </div>
						  <span className="leader-points">{value.points}<span className="border-bottom-red"> pts</span></span>
					  </div>
				  </a>
			  	</li>);
		  	}
			setLeaders(items.concat(leaders));
			setStartRank(data.start_rank);
		}
			localStorage.setItem("loader", "free");
		}
	}
	const getLeaderboardData = async () => {
		
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({dist_user_id:user_id}),
			
		};
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
		const data = await response.json();
		if (data.status !== "success"){
			setError(true);
		}

		for (const [index, value] of data.leaders.entries()) {
			let pp = '';
			if(value.profile_pic === 'NA' || value.profile_pic === ''){
				pp = require("./../images/defaultProfile.png").default;
			} else {
				pp = value.profile_pic;
			}
		  	items.push(<li key={value.dist_user_id}>
				<a className="item">
					<span className="leader-number">{value.rank}</span>
					<img src={pp} alt="image" className="image" />
					<div className="in">
						<div className="leader">
							{value.name}
							<footer className="leader-state">{value.city}</footer>
						</div>
						<span className="leader-points">{value.points}<span className="border-bottom-red"> pts</span></span>
					</div>
				</a>
			</li>);
		}
		setLeaders(items);
		setSeasonAward(data.season_data.banner);
		setLeaderData(data);
		setStartRank(data.start_rank);
		setEndRank(data.end_rank);
	};
	return (
<>
	{/* <HelmetProvider> */}
		<Helmet link={
			[{"rel": "stylesheet", "href": 'css/leaderboard.css'}]
		}/>
	{/* </HelmetProvider> */}
	<div className="row no-gutters">
		{ error1 === false && (
      	<div className="application bg-gradient">
        	<div className="appHeader bg-transparent text-light position-relative">
          		<div className="left">
					<a onClick={() => history.goBack()} className="headerButton goBack">
						<img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
					</a>
          		</div>
          	<div className="pageTitle">Leaderboard</div>
        </div>
        <div className="section">
            {/* <img src={seasonAward} alt="award" className="img-fluid d-block m-auto" /> */}
			<div className="w-100 d-block m-auto banner" style={{backgroundImage: `url(${seasonAward})`,backgroundSize: `100% 100%`}}></div>
        </div>

        <div className="section bg-grey leaderboard-section px-14" id="bg-grey" onScroll={onScroll}>
			{/* <button className="btn" type="button" onClick={() => loadMore('up')} value="up" >Load More</button> */}
			{/* <a onClick={() => loadMore('up')} className="">
				<img src={require("./../images/upLoadMore.png").default} alt="back" className="center" />
			</a> */}
            <ul className="listview image-listview leaderlist">
				{leaders}
            </ul>
			{/* <a onClick={() => loadMore('down')} className="">
				<img src={require("./../images/downLoadMore.png").default} alt="back" className="center" />
			</a> */}
			{/* <button className="btn" type="button" onClick={() => loadMore('down')} value="down" >Load More</button>   */}
        </div>

        <div className="section" id="fixed-footer">
            <ul className="listview image-listview leaderlist">        
				<li>
					<a className="item">
						<span className="leader-number">{leaderData.self.rank}</span>
						<img src={leaderData.self.profile_pic} alt="image" className="image"/>
						<div className="in">
							<div className="leader">
								{leaderData.self.name}
								<footer className="leader-state">{leaderData.self.city}</footer>
							</div>
							<span className="leader-points">{leaderData.self.points}<span className="border-bottom-red"> pts</span></span>
						</div>
					</a>
				</li>
			</ul>

        </div>
    </div>
		)}
		{ error1 === true && (
			<Redirect to='/'  />
		)}
		<div className="bg"></div>
	</div>
</>
	);
}

export default Leaderboard;
